import { getUserRegion } from '../../../../../utils';
import defaultConfig from './default-config';

const configMap = {
    default: defaultConfig,
};

const getConfig = () => {
    const region = getUserRegion();
    return configMap[region] || configMap.default;
};

export default getConfig;
